import { RootState } from "../../interfaces/RootState";

export default function selectIdToken(state: RootState): string {
    return state.hydrolink.auth.idToken;
}
